<script setup lang="ts">
const a11yStore = useA11yStore();
const { isMobile } = useGetDevice();
const { t } = useI18n();

const { fontSizeMode, enabled: a11yEnabled } = storeToRefs(a11yStore);

const fontSizeOptions: { label: string; value: '100' | '120' | '200' }[] = [
  { label: '100%', value: '100' },
  { label: '120%', value: '120' },
  { label: '200%', value: '200' },
];

const isSelected = (value: string) => fontSizeMode.value === value;

const buttonText = computed(() => {
  return isMobile ? t('a11y.disableShort') : t('a11y.disable');
});
</script>

<template>
  <div
    id="accessibility-bar"
    class="relative z-[2] grid bg-dark-blue transition-[grid-template-rows] duration-300"
    :class="{
      'grid-rows-[0fr]': !a11yEnabled,
      'grid-rows-[1fr]': a11yEnabled,
    }"
    :inert="!a11yEnabled"
  >
    <div class="overflow-hidden">
      <div
        class="mx-auto flex w-full max-w-[--max-content-width] flex-nowrap items-center gap-3 px-[--horizontal-layout-padding] py-2 text-white md:flex-wrap"
      >
        <div class="flex shrink-0 items-center gap-x-3 gap-y-6">
          <GlassesIcon class="size-5" />
          <span class="text-h4">{{ $t('a11y.fontSize') }}</span>
        </div>
        <div class="flex w-full flex-wrap items-center justify-between gap-3">
          <div class="flex items-center gap-3">
            <BaseTab
              v-for="option in fontSizeOptions"
              :key="option.value"
              :label="option.label"
              :value="option.value"
              inverted
              :selected="isSelected(option.value)"
              @click="a11yStore.setFontSizeMode(option.value)"
            />
          </div>
          <BaseButton variant="outlined" inverted @click="a11yStore.toggleA11y">
            {{ buttonText }}
          </BaseButton>
        </div>
      </div>
    </div>
  </div>
</template>
